"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFileSmallerThan = void 0;
var isFileSmallerThan = function (file, maximumSizeInBytes) {
    if (!file) {
        throw new Error("Wizard: a file must be provided");
    }
    if (Array.isArray(file)) {
        throw new Error('Pass a single file to isFileSmallerThan');
    }
    return file.size < maximumSizeInBytes;
};
exports.isFileSmallerThan = isFileSmallerThan;
//# sourceMappingURL=isFileSmallerThan.js.map